/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Check: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M20.6036 2.5622L7.99179 15.1657L3.39638 10.5733C3.0184 10.2085 2.51216 10.0066 1.98669 10.0112C1.46122 10.0158 0.958566 10.2264 0.586989 10.5977C0.215411 10.9691 0.00464195 11.4714 7.57604e-05 11.9965C-0.00449043 12.5216 0.197512 13.0275 0.562576 13.4053L6.57489 19.4136C6.95071 19.7891 7.46037 20 7.99179 20C8.52321 20 9.03287 19.7891 9.40869 19.4136L23.4374 5.39414C23.8025 5.01641 24.0045 4.5105 23.9999 3.98538C23.9954 3.46026 23.7846 2.95793 23.413 2.5866C23.0414 2.21527 22.5388 2.00464 22.0133 2.00008C21.4878 1.99551 20.9816 2.19738 20.6036 2.5622Z'
      fill='currentColor'
    />
  </React.Fragment>
)
